import { domAnimation, LazyMotion, MotionConfig } from "motion/react";

import type { ParentComponent } from "../lib/types";

interface Props {
	children: React.ReactNode;
}

const MotionProvider: ParentComponent<Props> = ({ children }) => (
	<LazyMotion features={domAnimation} strict>
		<MotionConfig reducedMotion="user">{children}</MotionConfig>
	</LazyMotion>
);

export { MotionProvider };
